export const isMirco = window.__POWERED_BY_QIANKUN__;
